import { render, staticRenderFns } from "./EditConnection.vue?vue&type=template&id=0a4df2da&scoped=true"
import script from "./EditConnection.vue?vue&type=script&lang=js"
export * from "./EditConnection.vue?vue&type=script&lang=js"
import style0 from "./EditConnection.vue?vue&type=style&index=0&id=0a4df2da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4df2da",
  null
  
)

export default component.exports